import { Injectable } from "@angular/core";
import { Observable, Subscriber } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FinalPageComponent } from "src/components/final-page/final-page.component";
import { environment } from 'src/environments/environment';
import { BASE_CONTACT_INFOPreferred_contact_method } from "src/models/common.model";
import { XPRESS_APPLICANT } from "src/models/xpress_loan.model";
import { CommonService } from './common.service';
import { HttpClient } from "@angular/common/http";
declare var Plaid:any;

@Injectable({
    providedIn: 'root'
})
export class PlaidService {

    authService: any ={};
    private _baseUrl = "";

    constructor(
        private httpClient: HttpClient, private commonService: CommonService
    ){
        this._baseUrl  = environment.baseUrl + "/api/";
        var openIdTokenParams = JSON.parse(localStorage.getItem('openIdTokenParams'));
        if (openIdTokenParams && openIdTokenParams.access_token) {
            this.authService.accessToken = openIdTokenParams.access_token;
        }
    }


    private handleError(error: Response){
        return Observable.throw(error.json());
    }

    createTokenLink():Observable<any>{
      return this
      .httpClient
      .get(this._baseUrl + "plaid/create-token-link", this.commonService.getAuthHeader(true)).pipe(
        catchError((err) => {
          return this.commonService.handleError(err);
        })
      )
    }


    createDepositSwitchAlt(depositSwitch):Observable<any>{
        return this
        .httpClient
        .post(this._baseUrl + "plaid/create-deposit-switch-alt", depositSwitch, this.commonService.getAuthHeader(true)).pipe(
          catchError((err) => {
            return this.commonService.handleError(err);
          })
        )
    }

    exchangeToken(publicToken){
        return this
        .httpClient
        .get(this._baseUrl + "plaid/exchange-token/"+publicToken , this.commonService.getAuthHeader(true)).pipe(
          catchError((err) => {
            return this.commonService.handleError(err);
          })
        )
    }

    showPlaidDeposit(applicant: XPRESS_APPLICANT, account_number: string): Observable<any>{

        var phone = "";
        if(applicant.preferred_contact_method == BASE_CONTACT_INFOPreferred_contact_method.CELL) {phone = applicant.cell_phone}
        if(applicant.preferred_contact_method == BASE_CONTACT_INFOPreferred_contact_method.HOME) {phone = applicant.home_phone}
        if(applicant.preferred_contact_method == BASE_CONTACT_INFOPreferred_contact_method.WORK) {phone = applicant.work_phone}

        var depositSwitch = {

            "target_account": {
               "account_number": account_number, //"000031567",
            },
            "target_user": {
               "given_name": applicant.first_name,
               "family_name": applicant.last_name,
               "phone": phone,
               "address": {
                 "street": applicant.CURRENT_ADDRESS.LOOSE_ADDRESS.street_address_1,
                 "city": applicant.CURRENT_ADDRESS.LOOSE_ADDRESS.city,
                 "region": applicant.CURRENT_ADDRESS.LOOSE_ADDRESS.state,
                 "postal_code": applicant.CURRENT_ADDRESS.LOOSE_ADDRESS.zip,
                 "country":"US"
                },
               "email": applicant.email,
             }
          }

          return new Observable(subscriber =>{
            this.createDepositSwitchAlt(depositSwitch).subscribe(r=>{
                const handler = Plaid.create({
                  token: r.link_token,
                  onSuccess: (public_token, metadata) => {
                    subscriber.next(metadata);
                    FinalPageComponent.isLoading = false;
    
                    //it's done here. we don't need to get access_token
    
                    // this.exchangeToken(public_token).subscribe(exToken=>{
                    // })
          
                  },
                  onLoad: () => {},
                  onExit: (err, metadata) => {
                    subscriber.error(metadata);
                    FinalPageComponent.isLoading = false;
                  },
                  onEvent: (eventName, metadata) => {
                  },
                  receivedRedirectUri: null,
                });
                setTimeout(()=>{
                  handler.open()
                },1)
              })
          })

         
    }

    link(): Promise<any> {
      return new Promise((resolve, reject) => {
        this.createTokenLink().subscribe((r) => {
            const config = {
              onSuccess: (public_token, metadata) => {
                this.getAuth(public_token).subscribe(
                  (r_getAuth) => {
                    resolve(r_getAuth);
                  },
                  (error) => {
                    reject(error);
                  }
                );
              },
              onExit: (err, metadata) => {
                reject({isExit : true, error : err});
              },
              onEvent: (eventName, metadata) => {
              },
              token:  r.link_token
            } as any;
        
            const handler = Plaid.create(config);
            handler.open();  
        });
      })
    }

    getAuth(public_token):Observable<any>{
      return this
      .httpClient
      .get(this._baseUrl + "plaid/get-auth/"+public_token, this.commonService.getAuthHeader(true)).pipe(
        catchError((err) => {
          return this.commonService.handleError(err);
        })
      )
    }

}